import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import MissingActualCorpNameAlert from "../components/MissingActualCorpNameAlert";
import { useAuth } from "./AuthContext";
import { BASE_URL } from "../config";

const MissingActualCorpNameAlertContext = createContext();

export const MissingActualCorpNameAlertProvider = ({ children }) => {
  const [showAlert, setShowAlert] = useState(false);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;

    const checkMissingActualCorpName = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/missing-actual-corp-name`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        if (response.data.data.corporates.length > 0) {
          setShowAlert(true);
        }
      } catch (err) {
        console.error("Error checking missing actual_corp_name:", err);
      }
    };

    checkMissingActualCorpName();
  }, [isAuthenticated]);

  return (
    <MissingActualCorpNameAlertContext.Provider value={{ showAlert, setShowAlert }}>
      {showAlert && <MissingActualCorpNameAlert onClose={() => setShowAlert(false)} />}
      {children}
    </MissingActualCorpNameAlertContext.Provider>
  );
};

export const useMissingActualCorpNameAlert = () => useContext(MissingActualCorpNameAlertContext);